export default "__VITE_ASSET__CWQvB8cN__"